<template>
  <el-container>
    <el-header height="220">
      <h3>面试题列表</h3>
      <el-row style="margin-top: 10px">
        <el-select
          v-model="queryInfo.categoryId"
          clearable
          style="margin-left: 5px"
          @change="onSelectChange"
        >
          <el-option
            v-for="(item, index) in categoryList"
            :key="index"
            :label="item.name"
            :value="item.id"
          />
        </el-select>
      </el-row>
    </el-header>
    <el-main>
      <el-table
        :data="dataList"
        border
        height="480"
        style="width: 100%"
      >
        <el-table-column
          fixed="left"
          label="No"
          type="index"
        />
        <el-table-column
          prop="title"
          label="标题"
        />
        <el-table-column
          prop="category"
          label="分类"
        >
          <template slot-scope="scope">
            <el-tag>
              <span>{{ scope.row.category }}</span>
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column
          prop="tag"
          label="标签"
        >
          <template slot-scope="scope">
            <el-tag style="margin: 5px" type="warning">
              <span>{{ scope.row.tag }}</span>
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column
          fixed="right"
          label="操作"
          width="280"
        >
          <template slot-scope="scope">
            <el-button
              style="margin-top: 5px; margin-left: 5px"
              size="mini"
              type="info"
              @click="handleDetail(scope.$index, scope.row)"
            >详情</el-button>
            <el-button
              style="margin-top: 5px; margin-left: 5px"
              size="mini"
              type="success"
              @click="handleAddWeight(scope.$index, scope.row)"
            >加</el-button>
            <el-button
              style="margin-top: 5px; margin-left: 5px"
              size="mini"
              type="warning"
              @click="handleMinusWeight(scope.$index, scope.row)"
            >减</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        background
        :small="screenWidth <= 768"
        layout="prev, pager, next"
        :page-size="pageSize"
        :current-page="currentPage"
        :total="totalSize"
        @current-change="handleCurrentChange"
        @prev-click="handleCurrentChange"
        @next-click="handleCurrentChange"
      />

      <el-dialog
        title="详情"
        append-to-body
        :visible.sync="addDialog"
        center
      >
        <template>
          <markdown :source="addForm.content"></markdown>
        </template>
      </el-dialog>
    </el-main>
  </el-container>
</template>

<script>
import Markdown from 'vue-markdown'
import {
  getBlogCategoryList,
  getBlogQuestionList,
  addBlogQuestionWeight,
  minusBlogQuestionWeight
} from '@/api/blog'

export default {
  name: 'BlogQuestion',
  components: { Markdown },
  data() {
    return {
      categoryList: [],
      queryInfo: {
        pn: 1,
        categoryId: null
      },
      // 屏幕宽度, 为了控制分页条的大小
      screenWidth: document.body.clientWidth,
      currentPage: 1,
      pageSize: 100,
      totalSize: 0,
      dataList: [],
      addDialog: false,
      addForm: {
        content: ''
      }
    }
  },
  created() {
    const pageNumber = this.$route.query.pn
    if (pageNumber !== undefined && pageNumber !== null) {
      this.currentPage = parseInt(pageNumber)
      this.queryInfo.pn = parseInt(pageNumber)
    }
    const categoryId = this.$route.query.categoryId
    if (categoryId !== undefined && categoryId !== '') {
      this.queryInfo.categoryId = parseInt(categoryId)
    }

    const queryInfo = {}
    queryInfo.type = 'category'
    getBlogCategoryList(queryInfo).then(resp => {
      if (resp.code === 0) {
        this.categoryList = resp.data
      }
    })

    document.title = '面试题列表'
    this.getData()
  },
  methods: {
    handleCurrentChange(pageNumber) {
      this.queryInfo.pn = pageNumber
      this.$router.push({
        path: '/bg/blog/question',
        query: this.queryInfo
      })
      this.getData()
      // 回到顶部
      scrollTo(0, 0)
    },
    getData() {
      getBlogQuestionList(this.queryInfo).then(resp => {
        if (resp.code === 0) {
          const respData = resp.data
          this.dataList = respData.list
          this.totalSize = respData.totalSize
        } else {
          this.$message.error(resp.msg)
        }
      }).catch(error => {
        this.$message.error(error.message)
      })
    },
    handleDetail(index, row) {
      this.addForm.content = row.content
      this.addDialog = true
    },
    handleAddWeight(index, row) {
      const formData = new FormData()
      formData.append('questionId', row.questionId)
      addBlogQuestionWeight(formData).then(resp => {
        this.addDialog = false
        this.$message.info(resp.msg)
        this.getData()
      }).catch(error => {
        this.$message.error(error.message)
      })
    },
    handleMinusWeight(index, row) {
      const formData = new FormData()
      formData.append('questionId', row.questionId)
      minusBlogQuestionWeight(formData).then(resp => {
        this.addDialog = false
        this.$message.info(resp.msg)
        this.getData()
      }).catch(error => {
        this.$message.error(error.message)
      })
    },
    onSelectChange() {
      this.currentPage = 1
      this.queryInfo.pn = 1
      this.$router.push({
        path: '/bg/blog/question',
        query: this.queryInfo
      })
      this.getData()
    }
  }
}
</script>

<style scoped>
</style>
